// http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html#uk

import { modWith10Divisor, modWith100Divisor } from './lib/modulo-operations';

const isPluralTypeOne = (number) => (
  (modWith10Divisor(number) === 1) && modWith100Divisor(number) !== 11
);
const isPluralTypeFew = (number) => (
  ([2, 3, 4].includes(modWith10Divisor(number))) &&
  !([12, 13, 14].includes(modWith100Divisor(number)))
);
const isPluralTypeMany = (number) => (
  modWith10Divisor(number) === 0 ||
  [5, 6, 7, 8, 9].includes(modWith10Divisor(number)) ||
  [11, 12, 13, 14].includes(modWith100Divisor(number))
);

export default function pluralizationRules(count = 0) {
  if (isPluralTypeOne(count)) {
    return ['one'];
  }
  if (isPluralTypeFew(count)) {
    return ['few'];
  }
  if (isPluralTypeMany(count)) {
    return ['many'];
  }
  return ['other'];
}
